var B = Object.defineProperty;
var v = (l, t, s) => t in l ? B(l, t, { enumerable: !0, configurable: !0, writable: !0, value: s }) : l[t] = s;
var h = (l, t, s) => v(l, typeof t != "symbol" ? t + "" : t, s);
import { b as C, p as R } from "./dev-D3SS6qhA.js";
const d = /^Format:[\s\t]*/, F = /^Style:[\s\t]*/, w = /^Dialogue:[\s\t]*/, g = /[\s\t]*,[\s\t]*/, I = /\{[^}]+\}/g, x = /\\N/g, M = /^\[(.*)[\s\t]?Styles\]$/, S = /^\[(.*)[\s\t]?Events\]$/;
class L {
  constructor() {
    h(this, "_init");
    h(this, "_section", 0);
    h(this, "_cue", null);
    h(this, "_cues", []);
    h(this, "_errors", []);
    h(this, "_format", null);
    h(this, "_errorBuilder");
    h(this, "_styles", {});
  }
  async init(t) {
    this._init = t, t.errors && (this._errorBuilder = (await import("./errors-Bfk1GqFn.js")).ParseErrorBuilder);
  }
  parse(t, s) {
    var e, r;
    if (this._section)
      switch (this._section) {
        case 1:
          if (t === "")
            this._section = 0;
          else if (F.test(t))
            if (this._format) {
              const a = t.replace(F, "").split(g);
              this._parseStyles(a);
            } else
              this._handleError((e = this._errorBuilder) == null ? void 0 : e._missingFormat("Style", s));
          else d.test(t) ? this._format = t.replace(d, "").split(g) : S.test(t) && (this._format = null, this._section = 2);
          break;
        case 2:
          if (t === "")
            this._commitCue();
          else if (w.test(t))
            if (this._commitCue(), this._format) {
              const a = t.replace(w, "").split(g), i = this._parseDialogue(a, s);
              i && (this._cue = i);
            } else
              this._handleError((r = this._errorBuilder) == null ? void 0 : r._missingFormat("Dialogue", s));
          else this._cue ? this._cue.text += `
` + t.replace(I, "").replace(x, `
`) : d.test(t) ? this._format = t.replace(d, "").split(g) : M.test(t) ? (this._format = null, this._section = 1) : S.test(t) && (this._format = null);
      }
    else t === "" || (M.test(t) ? (this._format = null, this._section = 1) : S.test(t) && (this._format = null, this._section = 2));
  }
  done() {
    return {
      metadata: {},
      cues: this._cues,
      regions: [],
      errors: this._errors
    };
  }
  _commitCue() {
    var t, s;
    this._cue && (this._cues.push(this._cue), (s = (t = this._init).onCue) == null || s.call(t, this._cue), this._cue = null);
  }
  _parseStyles(t) {
    let s = "Default", e = {}, r, a = "center", i = "bottom", _, c = 1.2, n, f, u = 3, m = [];
    for (let p = 0; p < this._format.length; p++) {
      const A = this._format[p], o = t[p];
      switch (A) {
        case "Name":
          s = o;
          break;
        case "Fontname":
          e["font-family"] = o;
          break;
        case "Fontsize":
          e["font-size"] = `calc(${o} / var(--overlay-height))`;
          break;
        case "PrimaryColour":
          const k = E(o);
          k && (e["--cue-color"] = k);
          break;
        case "BorderStyle":
          u = parseInt(o, 10);
          break;
        case "BackColour":
          f = E(o);
          break;
        case "OutlineColour":
          const y = E(o);
          y && (n = y);
          break;
        case "Bold":
          parseInt(o) && (e["font-weight"] = "bold");
          break;
        case "Italic":
          parseInt(o) && (e["font-style"] = "italic");
          break;
        case "Underline":
          parseInt(o) && (e["text-decoration"] = "underline");
          break;
        case "StrikeOut":
          parseInt(o) && (e["text-decoration"] = "line-through");
          break;
        case "Spacing":
          e["letter-spacing"] = o + "px";
          break;
        case "AlphaLevel":
          e.opacity = parseFloat(o);
          break;
        case "ScaleX":
          m.push(`scaleX(${parseFloat(o) / 100})`);
          break;
        case "ScaleY":
          m.push(`scaleY(${parseFloat(o) / 100})`);
          break;
        case "Angle":
          m.push(`rotate(${o}deg)`);
          break;
        case "Shadow":
          c = parseInt(o, 10) * 1.2;
          break;
        case "MarginL":
          e["--cue-width"] = "auto", e["--cue-left"] = parseFloat(o) + "px";
          break;
        case "MarginR":
          e["--cue-width"] = "auto", e["--cue-right"] = parseFloat(o) + "px";
          break;
        case "MarginV":
          _ = parseFloat(o);
          break;
        case "Outline":
          r = parseInt(o, 10);
          break;
        case "Alignment":
          const b = parseInt(o, 10);
          switch (b >= 4 && (i = b >= 7 ? "top" : "center"), b % 3) {
            case 1:
              a = "start";
              break;
            case 2:
              a = "center";
              break;
            case 3:
              a = "end";
              break;
          }
      }
    }
    if (e._vertical = i, e["--cue-white-space"] = "normal", e["--cue-line-height"] = "normal", e["--cue-text-align"] = a, i === "center" ? (e["--cue-top"] = "50%", m.push("translateY(-50%)")) : e[`--cue-${i}`] = (_ || 0) + "px", u === 1 && (e["--cue-padding-y"] = "0"), (u === 1 || f) && (e["--cue-bg-color"] = u === 1 ? "none" : f), u === 3 && n && (e["--cue-outline"] = `${r}px solid ${n}`), u === 1 && typeof r == "number") {
      const p = f ?? "#000";
      e["--cue-text-shadow"] = [
        n && T(r * 1.2, c * 1.2, n),
        n ? T(r * (r / 2), c * (r / 2), p) : T(r, c, p)
      ].filter(Boolean).join(", ");
    }
    m.length && (e["--cue-transform"] = m.join(" ")), this._styles[s] = e;
  }
  _parseDialogue(t, s) {
    const e = this._buildFields(t), r = this._parseTimestamp(e.Start, e.End, s);
    if (!r)
      return;
    const a = new C(r[0], r[1], ""), i = { ...this._styles[e.Style] || {} }, _ = e.Name ? `<v ${e.Name}>` : "", c = i._vertical, n = e.MarginL && parseFloat(e.MarginL), f = e.MarginR && parseFloat(e.MarginR), u = e.MarginV && parseFloat(e.MarginV);
    return n && (i["--cue-width"] = "auto", i["--cue-left"] = n + "px"), f && (i["--cue-width"] = "auto", i["--cue-right"] = f + "px"), u && c !== "center" && (i[`--cue-${c}`] = u + "px"), a.text = _ + t.slice(this._format.length - 1).join(", ").replace(I, "").replace(x, `
`), delete i._vertical, Object.keys(i).length && (a.style = i), a;
  }
  _buildFields(t) {
    const s = {};
    for (let e = 0; e < this._format.length; e++)
      s[this._format[e]] = t[e];
    return s;
  }
  _parseTimestamp(t, s, e) {
    var i, _, c;
    const r = R(t), a = R(s);
    if (r !== null && a !== null && a > r)
      return [r, a];
    r === null && this._handleError((i = this._errorBuilder) == null ? void 0 : i._badStartTimestamp(t, e)), a === null && this._handleError((_ = this._errorBuilder) == null ? void 0 : _._badEndTimestamp(s, e)), r != null && a !== null && a > r && this._handleError((c = this._errorBuilder) == null ? void 0 : c._badRangeTimestamp(r, a, e));
  }
  _handleError(t) {
    var s, e;
    if (t) {
      if (this._errors.push(t), this._init.strict)
        throw this._init.cancel(), t;
      (e = (s = this._init).onError) == null || e.call(s, t);
    }
  }
}
function E(l) {
  const t = parseInt(l.replace("&H", ""), 16);
  if (t >= 0) {
    const e = (t >> 24 & 255 ^ 255) / 255, r = t >> 16 & 255, a = t >> 8 & 255;
    return "rgba(" + [t & 255, a, r, e].join(",") + ")";
  }
  return null;
}
function T(l, t, s) {
  const e = Math.ceil(2 * Math.PI * l);
  let r = "";
  for (let a = 0; a < e; a++) {
    const i = 2 * Math.PI * a / e;
    r += l * Math.cos(i) + "px " + t * Math.sin(i) + "px 0 " + s + (a == e - 1 ? "" : ",");
  }
  return r;
}
function $() {
  return new L();
}
export {
  L as SSAParser,
  $ as default
};
